import React from 'react';
import { cn } from '@/utils/utils';

interface LoadingSpinnerProps {
  className?: string;
  /** Lureo's one spinner: the brand's bright mint, as production drew it, or the text colour of the fill it sits on (a deep fill, the call to action). */
  tone?: keyof typeof toneClasses;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-8 w-8',
  xl: 'h-12 w-12'
};

const toneClasses = {
  mint: 'text-lureo-mint',
  brand: 'text-lureo-brand-ink',
  'on-emphasis': 'text-lureo-on-emphasis',
  'on-cta': 'text-lureo-on-cta'
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  className = '',
  tone = 'mint',
  size = 'lg'
}) => {
  const finalClassName = cn('animate-spin', sizeClasses[size], toneClasses[tone], className);

  return (
    <svg
      className={finalClassName}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24">
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}; 